'use client'

import type { ReactNode } from 'react'
import type {
	DropdownMenuItemProps,
	SRT_RowData,
	SRT_TableInstance,
} from '../../types'

import React from 'react'

import { Button } from '@/shared/components/ui/button'
import { DropdownMenuItem } from '@/shared/components/ui/dropdown-menu'

export type SRT_ActionMenuItemProps<TData extends SRT_RowData> = {
	icon: ReactNode
	label: string
	onOpenSubMenu?: (event: React.MouseEvent | React.KeyboardEvent) => void
	table: SRT_TableInstance<TData>
} & DropdownMenuItemProps

export const SRT_ActionMenuItem = <TData extends SRT_RowData>({
	icon,
	label,
	onOpenSubMenu,
	table,
	onClick,
	...rest
}: SRT_ActionMenuItemProps<TData>) => {
	const {
		options: {
			icons: { ArrowRightIcon },
		},
	} = table

	return (
		<DropdownMenuItem
			className='flex min-w-[120px] items-center justify-between py-1.5'
			onClick={onClick}
			{...rest}
		>
			<div className='flex items-center gap-2 [&>svg]:size-4'>
				{icon}
				{label}
			</div>
			{onOpenSubMenu && (
				<Button
					variant='ghost'
					size='icon-sm'
					className='h-auto p-0'
					onClick={onOpenSubMenu}
					onMouseEnter={onOpenSubMenu}
				>
					<ArrowRightIcon />
				</Button>
			)}
		</DropdownMenuItem>
	)
}
